import { Base } from "./base";

export class CentralAtendimento extends Base {
  public descricao!: string;
}
